/* @flow */
import React from 'react';
import once from 'lodash/once';
import Image from 'components/Image';
import partition from 'lodash/partition';
import Legend from 'components/Legend';
import Button from 'components/Button';
import Divider from 'components/Divider';
import Fieldset from 'components/Fieldset';
import LoadingIndicator from 'components/LoadingIndicator';
import { showAccountLinkingToasts } from 'utils/accountLinkingToast';

import './styles/LinkedAccountsSettingsView.scss';

type Props = {
  sources: *,
  link: Function,
  unlink: Function,
  loading: boolean,
};

class LinkedAccountsSettings extends React.Component<Props, {}> {
  componentWillUpdate(nextProps: Props) {
    if (this.props.sources) {
      if (nextProps.sources) {
        showAccountLinkingToasts(this.props.sources, nextProps.sources);
      }
    }
  }
  renderSourceButton = (source: *) => {
    if (source.linkedAccountInfo.isLinked) {
      return (
        <Button
          color="lava"
          size="xxsmall"
          target="_blank"
          level="secondary"
          data-test="unlink-button"
          onClick={() => this.props.unlink(source)}
          className="LinkedAccountsSettings-item-buttons">
          <span>Disconnect</span>
        </Button>
      );
    } else {
      return (
        <Button
          size="xxsmall"
          target="_blank"
          level="secondary"
          data-test="link-button"
          onClick={() => this.props.link(source)}
          className="LinkedAccountsSettings-item-buttons">
          <span>Connect</span>
        </Button>
      );
    }
  };

  renderSource = (source: *) => {
    return (
      <div className="LinkedAccountsSettings-item" key={source.providerKey}>
        <Image
          circle
          src={source.iconURL}
          className="LinkedAccountsSettings-item-logo GroupAvatar GroupAvatar--medium"
        />
        <div className="LinkedAccountsSettings-item-body">
          <div className="LinkedAccountsSettings-item-body-title">{source.title}</div>
          <div className="LinkedAccountsSettings-item-body-description">
            {source.productShortDescription}
          </div>
        </div>
        {this.renderSourceButton(source)}
      </div>
    );
  };

  renderSection = (sources: *, title: string) => {
    return (
      <React.Fragment>
        <Legend>{title}</Legend>
        {sources.map(this.renderSource)}
      </React.Fragment>
    );
  };

  warnUnconnectable = once((unconnectable: any) => {
    console.debug(unconnectable);
    console.error('container provided unconnectable sources, ignored.');
  });

  render() {
    if (this.props.loading) {
      return <LoadingIndicator />;
    }

    const [connectable, unconnectable] = partition(this.props.sources, a => !!a.linkedAccountInfo);
    const [connected, unconnected] = partition(connectable, a => a.linkedAccountInfo.isLinked);

    if (unconnectable.length > 0) {
      this.warnUnconnectable(unconnectable);
    }

    return (
      <Fieldset className="LinkedAccountsSettings">
        {connected.length > 0 && this.renderSection(connected, 'Connected to Remind')}
        {connected.length > 0 && unconnected.length > 0 ? <Divider size="xxxxlarge" /> : null}
        {unconnected.length > 0 && this.renderSection(unconnected, 'Available apps')}
      </Fieldset>
    );
  }
}

export default LinkedAccountsSettings;
